
import {SetupContext} from "vue";

export default {
  name: "Tabs",
  emits: ['update:selected'],
  props: {
    headers: {
      type: Array,
    },
    selected: {
      type: Number,
    },
    small: {
      type: Boolean,
      default: false
    }
  },
  setup(_: any, {emit}: SetupContext) {
    const onSelected = (index: Number) => {
      emit("update:selected", index);
    }

    return {onSelected};
  }
}
